import { createContext, useContext } from 'react';

export interface DialogContextValue {
  contentRef: HTMLDivElement | null;
}

export const DialogContext = createContext<DialogContextValue>({
  contentRef: null
});

export const useDialogContext = () => useContext(DialogContext);
